export default __webpack_public_path__ + "static/media/notfound.95f68fd7.png";